<template>
  <lm-modal
    :ref="modalName"
    :name="modalName"
    class="ModalMentionList"
    title="Your Notifications"
    full-height
    disable-tabindex
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <div
      v-if="mentions.length === 0"
      class="h-full flex items-center justify-center pb-20"
    >
      No new notifications to show.<br /><br /><br />
      You're all caught up, good job!
    </div>
    <template v-else>
      <ul class="mt-2">
        <li v-for="mention in mentions" :key="mention.key" class="m-4">
          <mention-item :mention="mention" />
        </li>
      </ul>
    </template>
    <template slot="footer">
      <lm-modal-button
        title="Dismiss All"
        type="primary"
        :disabled="mentions.length === 0"
        @click="dismissAll"
      />
    </template>
  </lm-modal>
</template>

<script>
import {mapGetters} from 'vuex'
import {Events, Modal} from '@/lib/definitions'
import LmModal from '@/components/ui/LmModal'
import LmModalButton from '@/components/ui/button/LmModalButton'
import MentionItem from '@/components/ui/mention/MentionItem'

export default {
  name: 'ModalMentionList',
  components: {
    LmModal,
    LmModalButton,
    MentionItem
  },
  data() {
    return {
      modalName: Modal.MENTION_LIST,
      Events
    }
  },
  computed: {
    ...mapGetters(['mentions'])
  },
  created() {},
  methods: {
    modalClosed() {
      if (this.mentions.some(m => !m.read)) {
        this.$store.dispatch('readAllMentions')
      }
    },
    dismissAll() {
      if (this.mentions.length > 0) {
        this.$store.dispatch('dismissAllMentions')
        this.$refs[this.modalName].close()
      }
    }
  }
}
</script>
